import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useResponsiveSidebar(storageKey) {
  const { pathname } = useLocation();
  const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 767px)').matches);
  const [open, setOpen] = useState(false);
  const [desktopCollapsed, setDesktopCollapsed] = useState(() => localStorage.getItem(storageKey) === '1');
  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)');
    const changed = () => { setMobile(media.matches); setOpen(false); };
    media.addEventListener('change', changed);
    return () => media.removeEventListener('change', changed);
  }, []);
  useEffect(() => { setOpen(false); }, [pathname]);
  const toggleCollapsed = () => {
    if (mobile) setOpen((value) => !value);
    else setDesktopCollapsed((value) => {
      localStorage.setItem(storageKey, value ? '0' : '1');
      return !value;
    });
  };
  return { mobile, open, setOpen, collapsed: mobile ? !open : desktopCollapsed, toggleCollapsed };
}